import React from "react";
import { Trans } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ExpensesDetailsCardInner from "../expenses-details/ExpensesDetailsCardInner";
import IncomeDetailsCardInner from "../income-details/IncomeDetailsCardInner";

const AllExpenses = () => {
  const dashboardData = useSelector((state) => state.dashboard.dashboardData);
  return (
    <>
      <div className="row mx-0 statics-details-row">
        <div
          className={`total-all-budgets-div position-relative total-all-budgets`}
        >
          <div className="row">
            <IncomeDetailsCardInner all={"all"} />
          </div>
        </div>
        <div className="total-all-sources">
          <div className="row">
            <ExpensesDetailsCardInner />
          </div>
        </div>
      </div>
      <div className="row">
        {dashboardData?.totalIncome == 0 &&
          dashboardData?.totalExpense == 0 && (
            <div className="col-12 no-data-screen-db">
              <p>
                <Trans
                  i18nKey="dashboard.noDataFound"
                  components={{
                    linkClick: (
                      <Link to={"/settings/edit-form/income"}>
                        <b></b>
                      </Link>
                    ),
                  }}
                />
              </p>
            </div>
          )}
      </div>
    </>
  );
};

export default AllExpenses;
